import React, { FC } from "react";

import CampaignBuilderForm from "../../components/redesign/modules/CampaignBuilderForm";
import { CAMPAIGN_PLAY_TYPE } from "../../constants/campaignPlayTypes";
import { CAMPAIGN_STEPS } from "../../types/campaignTypes";

const CrmRetargetingCreatePageRedesign: FC = () => (
  <CampaignBuilderForm
    mode="campaign"
    campaignPlayType={CAMPAIGN_PLAY_TYPE.CRM_RETARGETING}
    visibleOptionalPanels={[CAMPAIGN_STEPS.CRM_RETARGETING_SEGMENTS]}
  />
);

export default CrmRetargetingCreatePageRedesign;
